<div class="card">
    <div class="card-body">
        <div class="row">
            <div class="col-sm-12 col-md-4 col-lg-3">
                <label for="date-picker" class="control-label">{{
                    'supplier-regions.choose-region' | translate
                }}</label>
                <app-supplier-region-chooser
                    [selectedRegionID]="selectedSupplierRegionID"
                    (onSelect)="onSupplierRegionChanged($event)"
                >
                </app-supplier-region-chooser>
            </div>
            <div class="col-sm-12 col-md-4 col-lg-3">
                <label for="date-picker" class="control-label">{{
                    'supplier-resources.enabled-worktime-date-range' | translate
                }}</label>
                <lib-date-picker
                    id="date-picker"
                    [initialValue]="initialValue"
                    [initialDateRange]="initialDateRange"
                    (select)="onDateRangeSelected($event)"
                ></lib-date-picker>
            </div>
            <div class="col-sm-12 col-md-4 col-lg-3">
                <label for="worktime-enable-btn" class="control-label">{{
                    'supplier-resources.change-worktime-registration-state' | translate
                }}</label>
                <button
                    id="worktime-enable-btn"
                    *ngIf="
                        suppierWorktimeSettings.isWorktimeRegistrationEnabled;
                        else enable
                    "
                    (click)="onRegistrationButtonClicked(false)"
                    class="btn btn-block btn-danger"
                >
                    {{ 'supplier-resources.disable-worktime-registration' | translate }}
                </button>

                <ng-template #enable>
                    <button
                        (click)="onRegistrationButtonClicked(true)"
                        class="btn btn-block btn-success"
                    >
                        {{
                            'supplier-resources.enable-worktime-registration' | translate
                        }}
                    </button>
                </ng-template>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-3">
                <label for="open-logistics-map-btn" class="control-label">{{
                    'supplier-resources.logistics-map' | translate
                }}</label>
                <button
                    id="open-logistics-map-btn"
                    type="button"
                    class="btn btn-block btn-primary"
                    [disabled]="!selectedSupplierRegionID"
                    (click)="openLogisticsMap()"
                >
                    {{ 'supplier-resources.open-logistics-map' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>

<ng-template #logisticsMapModal let-modal>
    <div class="modal-header modal-fullscreen">
        <h4 class="modal-title" id="logistics-map-modal-title">
            {{ 'supplier-resources.logistics-map' | translate }}
        </h4>
        <button
            type="button"
            class="close"
            aria-label="Close button"
            aria-describedby="logistics-map-modal-title"
            (click)="modal.dismiss('Cross click')"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body logistics-map-modal-body p-0">
        <iframe
            *ngIf="logisticsMapUrl"
            [src]="logisticsMapUrl"
            class="logistics-map-iframe"
            title="logistics-map"
        ></iframe>
    </div>
</ng-template>
